import { render, staticRenderFns } from "./RiskcomponentSimple.vue?vue&type=template&id=7b875170&"
import script from "./RiskcomponentSimple.vue?vue&type=script&lang=js&"
export * from "./RiskcomponentSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports